import React from "react"
import Button from "../../../../atoms/Button"
import styles from "./index.module.scss"

const buttonData = [
  { option: "alert_quant", label: "Alertas Quanti" },
  { option: "reject_quant", label: "Rejeições Quanti" },
  { option: "reject_quali_semi_quant", label: "Rejeições Quali/ Semi Quanti" },
]

export const FilterAttentionPoints = ({ setActionFilter, actionFilter,  }) => {
  const handleButtonClick = (option) => {
    const newOutline = {
      [option]: !actionFilter[option],
    }
    setActionFilter((prev) => ({ ...prev, ...newOutline }))
  }

  return (
    <div className={styles.wrapperFilterAttentionPoints}>
      {buttonData.map((button) => (
        <Button
          key={button.option}
          className={actionFilter[button.option] ? styles[button.option] : ""}
          onClick={() => handleButtonClick(button.option)}
        >
          {button.label}
        </Button>
      ))}
    </div>
  )
}
